import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class TelaInicial extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/TelaInicialLookup" clearable={false} {...this.props} />;
  }
}

export default TelaInicial;
